<template>
  <div class="container-fluid">
    <div class="row">
      <LayoutLeftAuth />

      <div class="col-md-5">
        <div class="container h-full d-flex align-items-center justify-content-center flex-column">
          <div class="row d-flex flex-column text-center align-items-center">
            <img src="../../assets/img/blue-logo.png" class="logo-mobile-auth d-sm-none" />
            <div class="reset-title">Reset link sent!</div>
            <div class="reset-undertitle">We’ve sent a password reset link to your email. Check your inbox for further instructions.</div>
            <router-link class="back-link" to="/login">Go back to login</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutLeftAuth from './components/LayoutLeftAuth';

export default {
  name: 'VerifyEmail',
  components: {
    LayoutLeftAuth,
  },
};
</script>
<style scoped>
.reset-title {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: -0.72px;
  color: #131c36;
}
.reset-undertitle {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #3e475e;
  max-width: 347px;
  margin-top: 7px;
  margin-bottom: 39px;
}
.back-link {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.0875px;
  color: #2962ff;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/ForgotPasswordEmailSent.vue